import React, { useRef } from 'react';

import __ from '@vitafy/common-libraries/frontend/Translate';
import { VotesDistribution } from '../../server/domain/ReviewSummary';

type ReviewSummaryProps = {
  averageRating?: number;
  voteCount?: number;
  distribution?: VotesDistribution[];
  locale: string;
};

const hasEnoughItems = (distribution: any): boolean =>
  distribution.filter((obj: VotesDistribution) => obj.votes > 0).length >= 3;

const formattedAverageRating = (average: number): string => Number(average / 20).toFixed(1);

const ShowReviewFormLink: React.FC<ReviewSummaryProps> = ({ locale }) => {
  const normalLink = useRef<HTMLAnchorElement>(null);
  const collapsibleLink = useRef<HTMLAnchorElement>(null);
  return (
    <>
      <a style={{ display: 'none' }} id="review-summary-link--anchor" href="#review-form" ref={normalLink}>
        {__({ val: 'Write a review', locale })}
      </a>
      <a
        style={{ textAlign: 'end' }}
        onClick={(e) => {
          collapsibleLink.current.setAttribute('style', 'display: none');
          normalLink.current.setAttribute('style', 'display: inline-block;');
          if (typeof document !== 'undefined') {
            document
              .querySelectorAll("[data-collapse-target='#review-form'].btn.btn--outline")[0]
              .setAttribute('style', 'display: none;');
          }
        }}
        data-module="collapse"
        id="review-summary-link--collapsible"
        data-collapse-target="#review-form"
        data-collapse-disable-form-elements="true"
        ref={collapsibleLink}
        href="#review-form"
        aria-controls="review-form"
        aria-expanded="false"
        data-module-collapse="initialized"
      >
        {__({ val: 'Write a review', locale })}
      </a>
    </>
  );
};

const ReviewsSummary: React.FC<ReviewSummaryProps> = ({ averageRating, distribution = [], locale }) => (
  <>
    {hasEnoughItems(distribution) && (
      <div className="reviews-summary">
        <div className="row">
          <div className="small-12 medium-3 large-2 columns mb ptn reviews-summary__meta">
            <span className="reviews-summary__average">
              <span>{__({ val: 'average', locale })}:</span>
              <span className="average-value">{averageRating.toFixed(1)}</span>
            </span>
            <span className="reviews-summary__add">
              <ShowReviewFormLink locale={locale} />
            </span>
          </div>
          <div className="small-12 medium-9 large-10 columns reviews-summary__chart">
            {distribution.map((part, index) => (
              <div key={index} className="distribution-bar__wrapper">
                {/* <!-- mask: url(...) repeat-x 0 3px --> */}
                <span className="star-list-item__wrapper">
                  <span className="star-list-item">
                    <span>{5 - index}</span>
                    <span className="rating-box">
                      <span className="rating" />
                    </span>
                  </span>
                </span>
                <span className="distribution-bar">
                  <span className="distribution-bar__bg">
                    <span
                      className="distribution-bar__fill"
                      style={{
                        width: `${
                          distribution[index].percentage > 0 ? Math.max(distribution[index].percentage, 1) : 0
                        }%`,
                        paddingLeft: distribution[index].percentage > 0 ? '.3rem' : 0,
                        marginLeft: distribution[index].percentage == 0 ? '.3rem' : 0,
                        paddingRight: distribution[index].percentage > 0 ? '.3rem' : 0
                      }}
                    >
                      {`${Math.round(distribution[index].percentage)}%`}
                    </span>
                  </span>
                </span>
                <span className="distribution-bar__count">({distribution[index].votes})</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    )}
    {!hasEnoughItems(distribution) && averageRating && (
      <div className="reviews-summary">
        <div className="row">
          <div className="small-12 medium-3 large-2 mb ptn reviews-summary__meta">
            <span className="reviews-summary__average">
              <span>{__({ val: 'average', locale })}:</span>
              <span className="average-value">{averageRating.toFixed(1)}</span>
            </span>
          </div>
          <div className="small-12 medium-9 large-10 reviews-summary__chart">
            <span className="reviews-summary__add">
              <ShowReviewFormLink locale={locale} />
            </span>
          </div>
        </div>
      </div>
    )}
  </>
);

export default ReviewsSummary;
